export function TestTube(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
         strokeLinecap="round"
         strokeLinejoin="round"
        aria-hidden="true"
      >
        <path
          d="M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2"
          style={{ fill: 'none' }}
        />
        <path d="M6.453 15h11.094" />
        <path d="M8.5 2h7" />
      </svg>
    </div>
  );
}
